import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = { class: "card-label fw-bold fs-3 mb-1" }
const _hoisted_5 = { class: "badge badge-light-primary fs-8 align-middle ms-2" }
const _hoisted_6 = { class: "text-muted mt-1 fw-semobold fs-7" }
const _hoisted_7 = { class: "card-toolbar" }
const _hoisted_8 = { class: "svg-icon svg-icon-2" }
const _hoisted_9 = { class: "card-body pb-0" }
const _hoisted_10 = { class: "row mb-5" }
const _hoisted_11 = { class: "col-md-3 mb-2" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "col-md-3 mb-2" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "col-md-3 mb-2" }
const _hoisted_16 = { class: "col-md-3 mb-2" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "col-md-3 mb-2" }
const _hoisted_19 = { class: "input-group" }
const _hoisted_20 = { class: "card-body pt-0" }
const _hoisted_21 = {
  key: 0,
  class: "alert alert-primary d-flex align-items-center py-3 mb-5"
}
const _hoisted_22 = { class: "flex-grow-1" }
const _hoisted_23 = { class: "row g-5 g-xl-8 mb-5" }
const _hoisted_24 = { class: "col-xl col-md-6" }
const _hoisted_25 = { class: "card bg-light-primary card-xl-stretch mb-xl-8" }
const _hoisted_26 = { class: "card-body my-3" }
const _hoisted_27 = { class: "d-flex align-items-center" }
const _hoisted_28 = { class: "symbol symbol-40px me-4" }
const _hoisted_29 = { class: "symbol-label bg-primary" }
const _hoisted_30 = { class: "svg-icon svg-icon-1 svg-icon-white" }
const _hoisted_31 = { class: "fs-2 fw-bold text-gray-800" }
const _hoisted_32 = { class: "fs-7 text-gray-600" }
const _hoisted_33 = { class: "col-xl col-md-6" }
const _hoisted_34 = { class: "card bg-light-info card-xl-stretch mb-xl-8" }
const _hoisted_35 = { class: "card-body my-3" }
const _hoisted_36 = { class: "d-flex align-items-center" }
const _hoisted_37 = { class: "symbol symbol-40px me-4" }
const _hoisted_38 = { class: "symbol-label bg-info" }
const _hoisted_39 = { class: "svg-icon svg-icon-1 svg-icon-white" }
const _hoisted_40 = { class: "fs-2 fw-bold text-gray-800" }
const _hoisted_41 = { class: "fs-5 text-gray-500" }
const _hoisted_42 = { class: "col-xl col-md-6" }
const _hoisted_43 = { class: "card bg-light-success card-xl-stretch mb-xl-8" }
const _hoisted_44 = { class: "card-body my-3" }
const _hoisted_45 = { class: "d-flex align-items-center" }
const _hoisted_46 = { class: "symbol symbol-40px me-4" }
const _hoisted_47 = { class: "symbol-label bg-success" }
const _hoisted_48 = { class: "svg-icon svg-icon-1 svg-icon-white" }
const _hoisted_49 = { class: "fs-2 fw-bold text-gray-800" }
const _hoisted_50 = { class: "fs-7 text-gray-600" }
const _hoisted_51 = { class: "col-xl col-md-6" }
const _hoisted_52 = { class: "card bg-light-warning card-xl-stretch mb-xl-8" }
const _hoisted_53 = { class: "card-body my-3" }
const _hoisted_54 = { class: "d-flex align-items-center" }
const _hoisted_55 = { class: "symbol symbol-40px me-4" }
const _hoisted_56 = { class: "symbol-label bg-warning" }
const _hoisted_57 = { class: "svg-icon svg-icon-1 svg-icon-white" }
const _hoisted_58 = { class: "fs-2 fw-bold text-gray-800" }
const _hoisted_59 = { class: "col-xl col-md-6" }
const _hoisted_60 = { class: "card bg-light-danger card-xl-stretch mb-xl-8" }
const _hoisted_61 = { class: "card-body my-3" }
const _hoisted_62 = { class: "d-flex align-items-center" }
const _hoisted_63 = { class: "symbol symbol-40px me-4" }
const _hoisted_64 = { class: "symbol-label bg-danger" }
const _hoisted_65 = { class: "svg-icon svg-icon-1 svg-icon-white" }
const _hoisted_66 = { class: "fs-2 fw-bold text-gray-800" }
const _hoisted_67 = { class: "row g-5 g-xl-8 mb-5" }
const _hoisted_68 = { class: "col-xl-8" }
const _hoisted_69 = { class: "card card-xl-stretch mb-xl-8" }
const _hoisted_70 = { class: "card-header border-0 pt-5" }
const _hoisted_71 = { class: "card-title align-items-start flex-column" }
const _hoisted_72 = { class: "text-muted mt-1 fw-semobold fs-7" }
const _hoisted_73 = { class: "card-toolbar" }
const _hoisted_74 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary"
}
const _hoisted_75 = { class: "svg-icon svg-icon-2" }
const _hoisted_76 = { class: "card-body" }
const _hoisted_77 = {
  ref: "populationTrendChart",
  style: {"height":"350px"}
}
const _hoisted_78 = { class: "col-xl-4" }
const _hoisted_79 = { class: "card card-xl-stretch mb-xl-8" }
const _hoisted_80 = { class: "card-header border-0 pt-5" }
const _hoisted_81 = { class: "card-toolbar" }
const _hoisted_82 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary"
}
const _hoisted_83 = { class: "svg-icon svg-icon-2" }
const _hoisted_84 = { class: "card-body" }
const _hoisted_85 = {
  ref: "locationDistributionChart",
  style: {"height":"350px"}
}
const _hoisted_86 = { class: "row g-5 g-xl-8 mb-5" }
const _hoisted_87 = { class: "col-xl-6" }
const _hoisted_88 = { class: "card card-xl-stretch mb-xl-8" }
const _hoisted_89 = { class: "card-body" }
const _hoisted_90 = {
  ref: "activityLevelChart",
  style: {"height":"300px"}
}
const _hoisted_91 = { class: "col-xl-6" }
const _hoisted_92 = { class: "card card-xl-stretch mb-xl-8" }
const _hoisted_93 = { class: "card-body" }
const _hoisted_94 = {
  ref: "provinceComparisonChart",
  style: {"height":"300px"}
}
const _hoisted_95 = { class: "card card-xl-stretch mb-5" }
const _hoisted_96 = { class: "card-header border-0 pt-5" }
const _hoisted_97 = { class: "card-title align-items-start flex-column" }
const _hoisted_98 = { class: "text-muted mt-1 fw-semobold fs-7" }
const _hoisted_99 = { class: "card-toolbar" }
const _hoisted_100 = { class: "svg-icon svg-icon-2" }
const _hoisted_101 = { class: "card-body py-3" }
const _hoisted_102 = { class: "table-responsive" }
const _hoisted_103 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_104 = { class: "ps-4" }
const _hoisted_105 = { class: "text-dark fw-semibold d-block mb-1 fs-6" }
const _hoisted_106 = { class: "text-dark fw-semibold d-block mb-1 fs-6" }
const _hoisted_107 = { class: "text-dark fw-semibold d-block mb-1 fs-6" }
const _hoisted_108 = { class: "text-dark fw-semibold d-block mb-1 fs-6" }
const _hoisted_109 = { class: "text-dark fw-semibold d-block mb-1 fs-6" }
const _hoisted_110 = { class: "text-dark fw-semibold d-block mb-1 fs-6" }
const _hoisted_111 = { class: "d-flex align-items-center gap-2" }
const _hoisted_112 = ["onClick"]
const _hoisted_113 = ["onClick"]
const _hoisted_114 = { class: "d-flex justify-content-between align-items-center flex-wrap mt-5" }
const _hoisted_115 = { class: "d-flex flex-wrap py-2 mr-3" }
const _hoisted_116 = { class: "d-flex flex-wrap py-2" }
const _hoisted_117 = { class: "pagination" }
const _hoisted_118 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _cache[17] || (_cache[17] = _createTextVNode(" Statistik Burung Walet ", -1)),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.statsVersion === "v2" ? "MW IoT v2 · Tuya" : "MW IoT v1 · Lama"), 1)
        ]),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.statsVersion === "v2"
              ? "Kamera Tuya Bardi A50"
              : "Perangkat generasi lama (non-Tuya)") + " — " + _toDisplayString(_ctx.deviceCount) + " perangkat", 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.switchVersion && _ctx.switchVersion(...args))),
          class: "btn btn-sm btn-light me-2"
        }, [
          _cache[18] || (_cache[18] = _createElementVNode("i", { class: "bi bi-arrow-left-right me-1" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.statsVersion === "v2" ? "Lihat IoT v1" : "Lihat IoT v2"), 1)
        ]),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.refreshData && _ctx.refreshData(...args))),
          class: "btn btn-sm btn-light-primary me-2"
        }, [
          _createElementVNode("span", _hoisted_8, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr075.svg" })
          ]),
          _cache[19] || (_cache[19] = _createTextVNode(" Refresh Data ", -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterProvince) = $event)),
            class: "form-select",
            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
          }, [
            _cache[20] || (_cache[20] = _createElementVNode("option", { value: "" }, "Semua Provinsi", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.provinces, (province) => {
              return (_openBlock(), _createElementBlock("option", {
                key: province,
                value: province
              }, _toDisplayString(province), 9, _hoisted_12))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.filterProvince]
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterCity) = $event)),
            class: "form-select",
            onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
          }, [
            _cache[21] || (_cache[21] = _createElementVNode("option", { value: "" }, "Semua Kota", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCities, (city) => {
              return (_openBlock(), _createElementBlock("option", {
                key: city,
                value: city
              }, _toDisplayString(city), 9, _hoisted_14))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.filterCity]
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.timeRange) = $event)),
            class: "form-select",
            onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
          }, [...(_cache[22] || (_cache[22] = [
            _createElementVNode("option", { value: "day" }, "Hari Ini", -1),
            _createElementVNode("option", { value: "week" }, "Minggu Ini", -1),
            _createElementVNode("option", { value: "month" }, "Bulan Ini", -1),
            _createElementVNode("option", { value: "year" }, "Tahun Ini", -1)
          ]))], 544), [
            [_vModelSelect, _ctx.timeRange]
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedDeviceId) = $event)),
            class: "form-select"
          }, [
            _cache[23] || (_cache[23] = _createElementVNode("option", { value: "all" }, "Semua Perangkat", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredDeviceData, (d) => {
              return (_openBlock(), _createElementBlock("option", {
                key: d.device_id,
                value: String(d.device_id)
              }, _toDisplayString(d.name), 9, _hoisted_17))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.selectedDeviceId]
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _withDirectives(_createElementVNode("input", {
              type: "search",
              class: "form-control",
              placeholder: "Cari lokasi...",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.searchQuery) = $event)),
              onInput: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args))),
              name: "mw-stats-search",
              autocomplete: "off",
              autocorrect: "off",
              autocapitalize: "off",
              spellcheck: "false",
              readonly: "",
              onFocus: _cache[11] || (_cache[11] = ($event: any) => ($event.target.removeAttribute('readonly')))
            }, null, 544), [
              [_vModelText, _ctx.searchQuery]
            ]),
            _cache[24] || (_cache[24] = _createElementVNode("span", { class: "input-group-text" }, [
              _createElementVNode("i", { class: "bi bi-search" })
            ], -1))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      (_ctx.selectedDeviceId !== 'all')
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _cache[27] || (_cache[27] = _createElementVNode("i", { class: "bi bi-graph-up-arrow fs-3 me-3" }, null, -1)),
            _createElementVNode("span", _hoisted_22, [
              _cache[25] || (_cache[25] = _createTextVNode("Menampilkan statistik untuk perangkat: ", -1)),
              _createElementVNode("b", null, _toDisplayString(_ctx.scopedDeviceName), 1)
            ]),
            _createElementVNode("button", {
              class: "btn btn-sm btn-light",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectedDeviceId = 'all'))
            }, [...(_cache[26] || (_cache[26] = [
              _createElementVNode("i", { class: "bi bi-x-lg me-1" }, null, -1),
              _createTextVNode("Semua Perangkat ", -1)
            ]))])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("span", _hoisted_29, [
                    _createElementVNode("span", _hoisted_30, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen032.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.formatNumber(_ctx.kpiCrossings)), 1),
                  _createElementVNode("div", _hoisted_32, " Total Lintasan Walet (" + _toDisplayString(_ctx.timeRangeLabel) + ") ", 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("span", _hoisted_38, [
                    _createElementVNode("span", _hoisted_39, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen060.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_40, [
                    _createTextVNode(_toDisplayString(_ctx.formatNumber(_ctx.kpiIn)) + " ", 1),
                    _createElementVNode("span", _hoisted_41, "/ " + _toDisplayString(_ctx.formatNumber(_ctx.kpiOut)), 1)
                  ]),
                  _cache[28] || (_cache[28] = _createElementVNode("div", { class: "fs-7 text-gray-600" }, "Masuk / Keluar", -1))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("span", _hoisted_47, [
                    _createElementVNode("span", _hoisted_48, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr066.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.growthRate >= 0 ? "+" : "") + _toDisplayString(_ctx.growthRate.toFixed(1)) + "% ", 1),
                  _createElementVNode("div", _hoisted_50, " Pertumbuhan " + _toDisplayString(_ctx.timeRangeLabel), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("span", _hoisted_56, [
                    _createElementVNode("span", _hoisted_57, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen007.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.peakLabel), 1),
                  _cache[29] || (_cache[29] = _createElementVNode("div", { class: "fs-7 text-gray-600" }, "Jam Puncak (WIB)", -1))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("span", _hoisted_64, [
                    _createElementVNode("span", _hoisted_65, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen013.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.topLocationLabel), 1),
                  _cache[30] || (_cache[30] = _createElementVNode("div", { class: "fs-7 text-gray-600" }, "Lokasi Terpadat", -1))
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_67, [
        _createElementVNode("div", _hoisted_68, [
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("h3", _hoisted_71, [
                _cache[31] || (_cache[31] = _createElementVNode("span", { class: "card-label fw-bold fs-3 mb-1" }, "Tren Populasi Burung Walet", -1)),
                _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.timeRangeLabel), 1)
              ]),
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("button", _hoisted_74, [
                  _createElementVNode("span", _hoisted_75, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen024.svg" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_76, [
              _createElementVNode("div", _hoisted_77, null, 512)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_78, [
          _createElementVNode("div", _hoisted_79, [
            _createElementVNode("div", _hoisted_80, [
              _cache[32] || (_cache[32] = _createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
                _createElementVNode("span", { class: "card-label fw-bold fs-3 mb-1" }, "Distribusi Lokasi"),
                _createElementVNode("span", { class: "text-muted mt-1 fw-semobold fs-7" }, "Jumlah Burung per Area")
              ], -1)),
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("button", _hoisted_82, [
                  _createElementVNode("span", _hoisted_83, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen024.svg" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_84, [
              _createElementVNode("div", _hoisted_85, null, 512)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_86, [
        _createElementVNode("div", _hoisted_87, [
          _createElementVNode("div", _hoisted_88, [
            _cache[33] || (_cache[33] = _createElementVNode("div", { class: "card-header border-0 pt-5" }, [
              _createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
                _createElementVNode("span", { class: "card-label fw-bold fs-3 mb-1" }, "Tingkat Aktivitas"),
                _createElementVNode("span", { class: "text-muted mt-1 fw-semobold fs-7" }, "Berdasarkan Waktu Hari")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_89, [
              _createElementVNode("div", _hoisted_90, null, 512)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_91, [
          _createElementVNode("div", _hoisted_92, [
            _cache[34] || (_cache[34] = _createElementVNode("div", { class: "card-header border-0 pt-5" }, [
              _createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
                _createElementVNode("span", { class: "card-label fw-bold fs-3 mb-1" }, "Perbandingan Provinsi"),
                _createElementVNode("span", { class: "text-muted mt-1 fw-semobold fs-7" }, "Total Populasi Burung Walet")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_93, [
              _createElementVNode("div", _hoisted_94, null, 512)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_95, [
        _createElementVNode("div", _hoisted_96, [
          _createElementVNode("h3", _hoisted_97, [
            _cache[35] || (_cache[35] = _createElementVNode("span", { class: "card-label fw-bold fs-3 mb-1" }, "Detail Data Perperangkat", -1)),
            _createElementVNode("span", _hoisted_98, _toDisplayString(_ctx.filteredDeviceData.length) + " Perangkat Terdaftar", 1)
          ]),
          _createElementVNode("div", _hoisted_99, [
            _createElementVNode("button", {
              class: "btn btn-sm btn-light-primary",
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.exportToCSV && _ctx.exportToCSV(...args)))
            }, [
              _createElementVNode("span", _hoisted_100, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil007.svg" })
              ]),
              _cache[36] || (_cache[36] = _createTextVNode(" Export CSV ", -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_101, [
          _createElementVNode("div", _hoisted_102, [
            _createElementVNode("table", _hoisted_103, [
              _cache[39] || (_cache[39] = _createElementVNode("thead", null, [
                _createElementVNode("tr", { class: "fw-bold text-muted bg-light" }, [
                  _createElementVNode("th", { class: "ps-4 min-w-100px rounded-start" }, "ID Perangkat"),
                  _createElementVNode("th", { class: "min-w-125px" }, "Lokasi"),
                  _createElementVNode("th", { class: "min-w-125px" }, "Provinsi"),
                  _createElementVNode("th", { class: "min-w-100px" }, "Kota"),
                  _createElementVNode("th", { class: "min-w-100px" }, "Total Lintasan"),
                  _createElementVNode("th", { class: "min-w-125px" }, "Terakhir Update"),
                  _createElementVNode("th", { class: "min-w-200px" }, "Status"),
                  _createElementVNode("th", { class: "min-w-150px rounded-end" }, "Aksi")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedDeviceData, (device) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: device.id
                  }, [
                    _createElementVNode("td", _hoisted_104, [
                      _createElementVNode("span", _hoisted_105, _toDisplayString(device.id), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_106, _toDisplayString(device.name), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_107, _toDisplayString(device.province), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_108, _toDisplayString(device.city), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_109, _toDisplayString(device.total_birds), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_110, _toDisplayString(_ctx.formatDate(device.last_updated)), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(`badge badge-light-${
                        device.online ? 'success' : 'danger'
                      } fw-semibold`)
                      }, _toDisplayString(device.online ? "Online" : "Offline"), 3)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_111, [
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-primary",
                          onClick: ($event: any) => (_ctx.viewDeviceStats(device.device_id)),
                          title: "Lihat statistik lengkap perangkat ini"
                        }, [...(_cache[37] || (_cache[37] = [
                          _createElementVNode("i", { class: "bi bi-graph-up-arrow me-1" }, null, -1),
                          _createTextVNode("Statistik ", -1)
                        ]))], 8, _hoisted_112),
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-icon btn-light",
                          onClick: ($event: any) => (_ctx.viewDeviceDetails(device.id)),
                          title: "Kelola perangkat (administratif)"
                        }, [...(_cache[38] || (_cache[38] = [
                          _createElementVNode("i", { class: "bi bi-gear" }, null, -1)
                        ]))], 8, _hoisted_113)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_114, [
            _createElementVNode("div", _hoisted_115, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.pageSize) = $event)),
                class: "form-select form-select-sm",
                style: {"width":"75px"}
              }, [...(_cache[40] || (_cache[40] = [
                _createElementVNode("option", { value: "5" }, "5", -1),
                _createElementVNode("option", { value: "10" }, "10", -1),
                _createElementVNode("option", { value: "20" }, "20", -1),
                _createElementVNode("option", { value: "50" }, "50", -1)
              ]))], 512), [
                [_vModelSelect, _ctx.pageSize]
              ])
            ]),
            _createElementVNode("div", _hoisted_116, [
              _createElementVNode("ul", _hoisted_117, [
                _createElementVNode("li", {
                  class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === 1 }])
                }, [
                  _createElementVNode("a", {
                    class: "page-link",
                    href: "#",
                    onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.changePage(_ctx.currentPage - 1)), ["prevent"]))
                  }, [...(_cache[41] || (_cache[41] = [
                    _createElementVNode("span", { class: "previous" }, null, -1)
                  ]))])
                ], 2),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: page,
                    class: _normalizeClass(["page-item", { active: page === _ctx.currentPage }])
                  }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#",
                      onClick: _withModifiers(($event: any) => (_ctx.changePage(page)), ["prevent"])
                    }, _toDisplayString(page), 9, _hoisted_118)
                  ], 2))
                }), 128)),
                _createElementVNode("li", {
                  class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === _ctx.totalPages }])
                }, [
                  _createElementVNode("a", {
                    class: "page-link",
                    href: "#",
                    onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_ctx.changePage(_ctx.currentPage + 1)), ["prevent"]))
                  }, [...(_cache[42] || (_cache[42] = [
                    _createElementVNode("span", { class: "next" }, null, -1)
                  ]))])
                ], 2)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}